import { connect } from 'react-redux'
import CustomItem from './view'

export default connect(null, {})(CustomItem)
